import React, { Component } from 'react';
import { Row, Field, Label }  from '../../generic';
import TextInput from '../../generic/fields/TextInput';
import styled from 'styled-components';

const LogoImage = styled.img`
  opacity: 1;
  max-width: 150px;
  max-height: 150px;
  margin-top: 10px;
`

const Wrap = styled.div`
  margin: 0 0 16px;
  @media screen and (min-width: 600px) {
    margin: 0 0 16px;
  }
`

class Message extends Component {
  render() {
    const { userEvent, onChange } = this.props
  	let multilineMessage = userEvent.invitation_message.split ('\n').map ((item, i) => <p key={i}>{item}</p>)
    return (
      <Wrap public={this.props.public}>
        <h1>An invitation from {userEvent.host_name}</h1>
        {multilineMessage}
      </Wrap>
    )
  }
}

export default Message
